import type { SVGProps } from "react";
// generated from LayoutLeft.svg — do not edit manually
// prettier-ignore
export default function LayoutLeft(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 9 4 H 3 V 20 H 9 M 9 4 H 21 V 20 H 9 M 9 4 V 20" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
